import Address from './Address';
import BaseModel from './BaseModel';
import Resource from './Resource';
import * as AT from '../../components/container/attributes';
import {required} from '@vuelidate/validators';

export default class ResourceSupplier extends BaseModel {
  constructor({
    id,
    supplier,
    resource,
    price,
    _supplierOrderNumber,
    _supplierDesignation,
  }) {
    super(id, '', '');
    this.supplier = supplier ? new Address(supplier) : null;
    this.resource = resource ? new Resource(resource) : null;
    this.price = price;
  }

  static get fkName() {
    return null;
  }
  static get apiRoute() {
    return 'resource_supplier';
  }
  static get listPageRoute() {
    return null;
  }
  static get detailPageRoute() {
    return null;
  }
  static get createInitColumns() {
    return {};
  }
  static get orderKey() {
    return 'price';
  }
  get fkName() {
    return ResourceSupplier.fkName;
  }
  get apiRoute() {
    return ResourceSupplier.apiRoute;
  }
  get detailPageRoute() {
    return ResourceSupplier.detailPageRoute;
  }
  get listPageRoute() {
    return ResourceSupplier.listPageRoute;
  }
  get createInitColumns() {
    return ResourceSupplier.createInitColumns;
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes([
      'supplier',
      'price',
      'supplierOrderNumber',
      'supplierDesignation',
    ]);
  }

  static get allAttributes() {
    return [
      new AT.FkAddressAttribute({
        name: 'supplier',
        validations: {required},
        column: 'address_id',
        joinPath: ['fk_resource_supplier_address_id_address'],
        filters: {
          or: ['supplier.is.true', 'potential_supplier.is.true'],
        },
        tableProperties: {
          header: 'hit-app.common.supplier',
        },
      }),
      new AT.FkResourceAttribute({
        name: 'resource',
        column: 'resource_id',
        joinPath: ['fk_resource_supplier_resource_id_resource'],
        tableProperties: {
          header: 'hit-base.common.resource',
        },
      }),
      new AT.DecimalAttribute({
        name: 'price',
        decimalPrecision: 2,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.common.price',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'supplierOrderNumber',
        column: 'supplier_no',
        tableProperties: {
          header: 'hit-app.resource.supplier-order-number',
        },
      }),
      new AT.StringAttribute({
        name: 'supplierDesignation',
        column: 'supplier_designation',
        tableProperties: {
          header: 'hit-app.resource.supplier-designation',
        },
      }),
      new AT.DateAttribute({
        name: 'creationDate',
        column: 'creation_date',
        tableProperties: {
          header: 'hit-app.common.creation-date',
          maxWidth: '0.5fr',
        },
      }),
      new AT.DateAttribute({
        name: 'modificationDate',
        column: 'modification_date',
        tableProperties: {
          header: 'hit-app.common.modification_date',
          maxWidth: '0.5fr',
        },
      }),
    ];
  }
}
